export {
    regexMatch,
    regexLike,
    regexStartsWith,
    regexEndsWith
} from './string-regex';
